// extracted by mini-css-extract-plugin
export default {"dimensionPanel":"dimensionPanel__CombinableMetadataDimensions__4KAe4","note":"note__CombinableMetadataDimensions__4KAe4","strong":"strong__CombinableMetadataDimensions__4KAe4"};